module.exports = __webpack_public_path__ + "static/media/home-caro-6.6ba26a80.png";